import React from "react";

import "./stylesEmailNotificationForm.css";
import HTMLImage from "../../../../../assets/images/html.png";

import { PlusOutlined } from "@ant-design/icons";

function EmailNotificationForm() {
  return (
    <div className="formSection email-notification">
      <div className="email-notification-header">
        <h2>Email Variants</h2>
        <button>Save As Template</button>
      </div>
      <div className="email-variants">
        <div className="email-variant">
          <div>Variant 1</div>
        </div>
        <div className="email-variant add-new">
          <div>
            <PlusOutlined className="add-icon" />
            <span>Add new</span>
          </div>
        </div>
      </div>
      <div className="editing-experience">
        <div className="editing-experience-left-content">
          <h3>Select Your Editing Experience</h3>
          <span>Create your ideal Email with our HTML Editor</span>
        </div>
        <div className="editing-experience-right-content">
          <img src={HTMLImage} alt="HTML Editor" />
          <h3>HTML Editor</h3>
          <p>
            Feature-rich HTML editing with <br /> visual preview
          </p>
        </div>
      </div>
    </div>
  );
}

export default EmailNotificationForm;
